// Components==============
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext } from 'react';
import { GlobalContext } from 'utilities/GlobalContext';
import { useAudio } from 'utilities/useAudio';
import './Column.module.scss';
// =========================

type Props = {
    name: string;
    phoneme?: string;
    image?: string | null;
    children: React.ReactNode;
    useWords: 0 | 1;
    useImages: 0 | 1;
    showSpeaker?: 0 | 1;
    disableOverflow?: boolean;
    disablePadding?: boolean;
    isSound?: 0 | 1;
    background: Background;
};

export default function Column({
    name,
    image,
    phoneme,
    useWords,
    useImages,
    showSpeaker = 0,
    children,
    disableOverflow = false,
    disablePadding = false,
    isSound = 0,
    background,
}: Props) {
    const audio = isSound
        ? { audioFile: `/getKlankAudio/${name}` }
        : { text: name, phoneme };

    const hasAudio = !!(name && useWords);

    const { play, isPlaying, stop } = useAudio(hasAudio ? audio : {});

    const { keyboardIsOpen } = useContext(GlobalContext);

    return (
        <div styleName="wrapper">
            <div styleName="top">
                {!useImages || !image ? null : (
                    <img src={`/storage/${image}`} alt="" />
                )}
                {hasAudio && (
                    <motion.div
                        styleName={`text ${showSpeaker ? 'show-speaker' : ''}`}
                        onClick={() => (isPlaying ? stop() : play())}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        style={{
                            background:
                                background === 'desert' ? '#AD9993' : '',
                        }}
                    >
                        {showSpeaker ? (
                            <FontAwesomeIcon
                                styleName={`${
                                    isPlaying ? 'icon playing' : 'icon'
                                }`}
                                icon={
                                    isPlaying
                                        ? ['fas', 'stop']
                                        : ['fas', 'volume']
                                }
                            />
                        ) : null}
                        <h3 style={{ fontSize: name.length > 35 ? 18 : '' }}>
                            {name}
                        </h3>
                    </motion.div>
                )}
            </div>
            <div
                styleName="bottom"
                style={{
                    overflowY: keyboardIsOpen
                        ? 'initial'
                        : disableOverflow
                        ? 'initial'
                        : 'auto',
                    padding: disablePadding ? 0 : '',
                }}
            >
                {children}
            </div>
        </div>
    );
}
